export const BREADCRUMBS_LINK_SEPARATOR = '/';
export const HOME_PATH = BREADCRUMBS_LINK_SEPARATOR;
